exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  color: red; }\n\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 4.5vh; }\n  .checkbox-container input {\n    display: none; }\n  .checkbox-container .checkmark {\n    position: absolute;\n    top: 0.25vh;\n    left: 0;\n    height: 2.8vh;\n    width: 2.8vh;\n    border-radius: 0.5vh;\n    background: #eee;\n    border: 1px solid #ccc; }\n  .checkbox-container input:checked ~ .checkmark {\n    background: #0A73B8;\n    border: none; }\n  .checkbox-container .checkmark:after {\n    display: none;\n    position: absolute;\n    content: \"\";\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    top: 0.15vh;\n    left: 0.8vh;\n    height: 2vh;\n    width: 1vh;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg); }\n  .checkbox-container input:checked ~ .checkmark:after {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/new-password/new-password.component.scss
// module id = ../../../../../src/app/auth/new-password/new-password.component.scss
// module chunks = main